<app-header [forceLightBackground]="true"></app-header>
<div class="compute-credit-home">
  <div class="compute-credit-home--layout">
    <app-admin-sidebar class="compute-credit-home--sidebar"></app-admin-sidebar>
    <div class="compute-credit-home--content">
      <app-page-header></app-page-header>
      <div class="compute-credit-container">
        <!-- Tabs + Analytics Button -->
        <div class="tabs-container">
          <div class="tabs-header">
            <div class="tabs-header--left">
              <button
                *ngFor="let tab of tabs"
                class="tab-button"
                [class.active]="activeTab === tab.key"
                (click)="setActiveTab(tab.key)"
              >
                {{ tab.label }}
              </button>
            </div>
            <div class="tabs-header--actions">
              @if (workspace.canViewPlatformSuperset()) {
              <div class="view-toggle">
                <button
                  type="button"
                  class="view-toggle-btn"
                  [class.active]="!showAnalytics"
                  (click)="showAnalytics && toggleAnalytics()"
                  aria-label="Table view"
                  title="Table view"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2"></rect>
                    <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"></line>
                    <line x1="9" y1="10" x2="9" y2="20" stroke="currentColor" stroke-width="2"></line>
                    <line x1="15" y1="10" x2="15" y2="20" stroke="currentColor" stroke-width="2"></line>
                  </svg>
                </button>
                <button
                  type="button"
                  class="view-toggle-btn"
                  [class.active]="showAnalytics"
                  (click)="!showAnalytics && toggleAnalytics()"
                  aria-label="Superset view"
                  title="Superset view"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M4 19L10 13L14 17L20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M20 11V7H16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                </button>
              </div>
              }
              <button
                *ngIf="activeTab === 'compute-requests' && !showAnalytics"
                type="button"
                class="toolbar-export-btn"
                aria-label="Export table"
                (click)="onExport()"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                >
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  <polyline points="15 3 21 3 21 9" />
                  <line x1="10" y1="14" x2="21" y2="3" />
                </svg>
                <span>Export</span>
              </button>
            </div>
          </div>

          <!-- Inline Analytics Panel -->
          <div class="analytics-panel" *ngIf="showAnalytics">
            <div class="analytics-panel--body">
              <!-- Loading overlay -->
              <div class="analytics-panel--loading" *ngIf="analyticsLoading">
                <div class="analytics-panel--spinner"></div>
                <span>Loading dashboard</span>
              </div>

              <!-- Error state -->
              <div class="analytics-panel--error" *ngIf="analyticsError && !analyticsLoading">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                  <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                  <circle cx="12" cy="16" r="1" fill="currentColor"/>
                </svg>
                {{ analyticsError }}
              </div>

              <!-- Mount point -->
              <div
                #analyticsMount
                class="analytics-panel--mount"
                [class.hidden]="analyticsLoading || !!analyticsError"
              ></div>
            </div>
          </div>

          <!-- Tab Content -->
          <div class="tab-content-wrapper">
            <div class="tab-panel" *ngIf="activeTab === 'compute-requests' && !showAnalytics">
              <app-user-compute-requests
                #userComputeRequests
                [showExportButton]="false"
              ></app-user-compute-requests>
            </div>
            <div class="tab-panel" *ngIf="creditRequestsEnabled && activeTab === 'credit-requests' && !showAnalytics">
              <app-user-credit-requests #userCreditRequests></app-user-credit-requests>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
